import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./CashierUsers";

const CashierUsers = lazy(() => import("./CashierUsers"));

export default (props: Props) => (
  <Page>
    <CashierUsers {...props} />
  </Page>
);
